import React from 'react';

const Input = ({ type, placeholder, className = '', ...props }) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      className={`input
        bg-white
        border border-azul-oscuro/80
        text-azul-oscuro
        placeholder:text-azul-oscuro/60
        rounded-md
        px-4 py-2
        shadow-sm
        focus:outline-none
        focus:ring-2 focus:ring-azul-lago
        focus:border-azul-oscuro
        transition-all
        ${className}`}
      {...props}
    />
  );
};

export default Input;
